import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

// @mui material components
import Alert from "@mui/material/Alert";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";

// @mui material icons
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";

// Dashboard components
import {
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// React-Select component and styling
import "../../index.css";

// Functions from store
import {
  acceptVendorHandler,
  getVendorByVendorId,
  getVendorsNotApproved,
  rejectVendorHandler,
} from "../../store/vendor-details/vendorDetailsActions";

import Config from "../../config/index";

// Cookies
import Cookies from "universal-cookie";
const cookies = new Cookies();

const acceptStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const DashboardForm = ({
  getVendorByVendorId,
  getVendorByVendorIdReducer,
  getVendorsNotApprovedReducer,
  getVendorsNotApproved,
  acceptVendorHandlerReducer,
  acceptVendorHandler,
  rejectVendorHandler,
  getRejectHandler,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;

  let baseUrl = Config.baseUrl;

  const location = useLocation();
  const navigate = useNavigate();
  const { vendorUserId } = useParams();

  const [values, setValues] = useState({});
  console.log("values", values);
  useEffect(() => {
    getVendorByVendorId(vendorUserId, jwtToken);
  }, [vendorUserId]);

  const validSupplierName = values.validSupplierName;
  const gstSupplierName = values.gstSupplierName;
  const validPinCode = values.validPinCode;
  const gstPinCode = values.gstPinCode;
  const ValidAddress = values.ValidAddress;

  const enteredSupplierName = values.vendorName;
  const enteredPincode = values?.address?.pinCode;

  console.log("validSupplierName", validSupplierName);
  console.log("validPinCode", validPinCode);

  let loading = getVendorByVendorIdReducer.loading;

  // const documentEmail = values.email;
  // const getDocument = (filename) => {
  //   return (
  //     <a
  //       rel="noopener noreferrer"
  //       href={`${baseUrl}/vendor/get_document?email=${documentEmail}&file_name=${filename}`}
  //       target="_blank"
  //       className="btn"
  //       style={{ color: "white" }}
  //     >
  //       View
  //     </a>
  //   );
  // };

  const documentUserId = vendorUserId;

  // State to manage dialog visibility and selected document
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedDocumentUrl, setSelectedDocumentUrl] = useState("");

  const getDocument = (filename) => {
    return (
      <MDButton
        style={{ color: "white" }}
        color="primary"
        variant="contained"
        size="small"
        onClick={() => handleDocumentClick(filename)}
      >
        View
      </MDButton>
    );
  };

  const [isPDF, setIsPDF] = useState(false);

  // Handle the document click and open the dialog
  const handleDocumentClick = (documentDetails) => {
    fetch(
      `${baseUrl}/vendor/download_center/single_doc?vendorId=${documentUserId}&file_name=${documentDetails?.name}&file_type=${documentDetails?.type}`,
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        // If the S3 URL is not a direct PDF link, force it to open as PDF in iframe
        let url = data.url;
        //   if (url && !url.endsWith(".pdf")) {
        //     url = `https://docs.google.com/gview?url=${encodeURIComponent(
        //       url
        //     )}&embedded=true`;
        //   }
        //   setSelectedDocumentUrl(url);
        // })
        if (url && url.endsWith("pdf")) {
          url = `https://docs.google.com/gview?url=${encodeURIComponent(
            url,
          )}&embedded=true`;
          setIsPDF(true);
          setSelectedDocumentUrl(url);
        }
        if (
          url.endsWith("jpeg") ||
          url.endsWith("jpg") ||
          url.endsWith("png")
        ) {
          setIsPDF(false);
          setSelectedDocumentUrl(url);
          setTimeout(() => {
            setIsLoading(false);
          }, 1000);
          // Images load faster, so we can set loading to false immediately
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    setOpenDialog(true);
  };

  // Handle dialog close
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setIsLoading(true); // Reset loading state when closing the dialog
    setIsPDF(true);
  };

  const [openAcceptModal, setOpenAcceptModal] = useState(false);

  const handleOpenAcceptModal = (asset = {}) => {
    setOpenAcceptModal(true);
  };
  const handleCloseAcceptModal = () => {
    setOpenAcceptModal(false);
  };

  const [isErrorAccept, setIsErrorAccept] = useState(false);
  const [isSuccessAccept, setIsSuccessAccept] = useState(false);

  useEffect(() => {
    if (isErrorAccept) {
      setTimeout(() => {
        setIsErrorAccept(false);
      }, 3000);
    }
  }, [isErrorAccept]);

  useEffect(() => {
    if (isSuccessAccept) {
      setTimeout(() => {
        setIsSuccessAccept(false);
      }, 3000);
    }
  }, [isSuccessAccept]);

  const [openRejectModal, setOpenRejectModal] = useState(false);

  const handleOpenRejectModal = (asset = {}) => {
    setOpenRejectModal(true);
  };
  const handleCloseRejectModal = () => {
    setOpenRejectModal(false);
  };

  const [isErrorReject, setIsErrorReject] = useState(false);
  const [isSuccessReject, setIsSuccessReject] = useState(false);

  useEffect(() => {
    if (isErrorReject) {
      setTimeout(() => {
        setIsErrorReject(false);
      }, 3000);
    }
  }, [isErrorReject]);

  useEffect(() => {
    if (isSuccessReject) {
      setTimeout(() => {
        setIsSuccessReject(false);
      }, 3000);
    }
  }, [isSuccessReject]);

  const [comment, setComment] = useState("");
  const [statusVendorName, setStatusVendorName] = useState(false);
  const [statusGST, setStatusGST] = useState(false);
  const [statusPAN, setStatusPAN] = useState(false);
  const [statusGSTIN, setStatusGSTIN] = useState(false);
  const [statusVendorNameGSTIN, setStatusVendorNameGSTIN] = useState(false);
  const [statusPincodeGSTIN, setStatusPincodeGSTIN] = useState(false);

  const clickHandler = () => {
    if (location.pathname === `/rejected-suppliers/${vendorUserId}`) {
      navigate("/rejected-suppliers");
    }
    if (location.pathname === `/registered-suppliers/${vendorUserId}`) {
      navigate("/registered-suppliers");
    }
    if (location.pathname === `/status/${vendorUserId}`) {
      navigate("/status");
    }
  };

  const [errorMsgForAccept, setErrorMsgForAccept] = useState("");

  const acceptHandler = async () => {
    let payload = {
      vendorUserId: values.vendorId,
      companyCode: companyCode.value,
      vendorGroup: vendorGroup.value,
      remarks,
    };
    let response = await acceptVendorHandler(payload, jwtToken);

    if (response.status) {
      setIsSuccessAccept(true);

      navigate("/status");
    }
    if (!response.status) {
      setErrorMsgForAccept(response?.data?.data?.msg);
      setIsErrorAccept(true);
    }
  };

  const [errorMsgForReject, setErrorMsgForReject] = useState("");

  const rejectHandler = async () => {
    let payload = {
      rejectReason: comment,
      vendorUserId: values.vendorId,
    };
    let response = await rejectVendorHandler(payload, jwtToken);

    if (response.status) {
      setIsSuccessReject(true);

      navigate("/status");
    }
    if (!response.status) {
      setIsErrorReject(true);
      setErrorMsgForReject(response?.data?.data?.msg);
    }
  };

  useEffect(() => {
    getVendorsNotApproved(jwtToken);
  }, []);

  useEffect(() => {
    let data = getVendorByVendorIdReducer.getVendor
      ? getVendorByVendorIdReducer.getVendor
      : {};

    setValues(data);
    console.log(data);
  }, [getVendorByVendorIdReducer]);

  const valuesCompanyCode = [
    { label: "300", value: "300" },
    { label: "400", value: "400" },
    { label: "500", value: "500" },
  ];

  const valuesVendorGroup = [
    { label: "Raw Material", value: "Raw Material" },
    { label: "Capital(Supply)", value: "Capital(Supply)" },
    { label: "Capital(Service)", value: "Capital(Service)" },
    { label: "Non-Capital(Supply)", value: "Non-Capital(Supply)" },
    { label: "Non-Capital(Service)", value: "Non-Capital(Service)" },
  ];

  const [companyCode, setCompanyCode] = useState("");
  const [vendorGroup, setVendorGroup] = useState("");
  const [remarks, setRemarks] = useState("");

  const [isLoading, setIsLoading] = useState(true); // Loading state
  const handleIframeLoad = () => {
    setIsLoading(false);
    // Set loading to false once the iframe has loaded
  };

  return (
    <div>
      <DashboardLayout>
        <DashboardNavbar />
        {!loading ? (
          <MDCard>
            <MDBox mt={4}>
              <MDTypography
                variant="h3"
                fontWeight="medium"
                style={{ display: "grid", justifyContent: "center" }}
              >
                Supplier Form
              </MDTypography>
            </MDBox>

            <Dialog
              open={openDialog}
              onClose={handleCloseDialog}
              maxWidth="md"
              fullWidth
            >
              <DialogTitle>Document Preview</DialogTitle>
              <DialogContent>
                {/* <iframe
      src={selectedDocumentUrl}
      title="Document Preview"
      style={{ width: '100%', height: '400px', border: 'none' }}
    /> */}

                <Card
                  sx={{
                    borderRadius: "16px",
                    overflow: "hidden",
                    boxShadow: "0px 8px 25px rgba(0, 0, 0, 0.15)",
                    transition: "transform 0.3s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.02)",
                    },
                    width: "100%",
                    maxWidth: "1000px",
                  }}
                >
                  {isLoading && (
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  )}

                  {isPDF ? (
                    <iframe
                      src={selectedDocumentUrl}
                      title="VIEW"
                      width="100%"
                      height="800px"
                      style={{
                        border: "none",
                        borderRadius: "16px",
                        boxShadow: "0px 2px 15px rgba(0, 0, 0, 0.2)",
                        transition: "all 0.3s ease-in-out",
                        position: "relative",
                      }}
                      onLoad={handleIframeLoad} // Handle iframe load event
                    />
                  ) : (
                    <img
                      src={selectedDocumentUrl}
                      alt="VIEW"
                      width="100%"
                      style={{
                        borderRadius: "16px",
                        boxShadow: "0px 2px 15px rgba(0, 0, 0, 0.2)",
                        transition: "all 0.3s ease-in-out",
                      }}
                    />
                  )}
                </Card>
              </DialogContent>

              <DialogActions sx={{ padding: "16px", justifyContent: "center" }}>
                <MDButton
                  onClick={handleCloseDialog}
                  color="primary"
                  variant="contained"
                  sx={{
                    fontSize: "1rem",
                    padding: "8px 24px",
                    backgroundColor: "#007BFF",
                    "&:hover": {
                      backgroundColor: "#0056b3",
                    },
                  }}
                >
                  Close
                </MDButton>
              </DialogActions>
            </Dialog>

            <MDBox pt={1} pb={3} px={3}>
              <Formik>
                {(formik) => (
                  <Form>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        // aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <MDTypography
                          mt={5}
                          variant="h5"
                          fontWeight="medium"
                          color="inherit"
                        >
                          Business Partner Details
                        </MDTypography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid
                          container
                          spacing={1}
                          alignItems="center"
                          style={{ color: "black" }}
                        >
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // variant="inherit"
                                  // variant="subtitle2"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  Line of Business
                                </MDTypography>
                                <input
                                  fullWidth
                                  name="name"
                                  // color="inherit"
                                  // variant="inherit"
                                  value={values.lineOfBusiness}
                                  style={{
                                    color: "black",
                                    font: "inherit",
                                    fontSize: "14px",
                                    letterSpacing: "inherit",

                                    padding: "4px 0 5px",
                                    border: "0.2px solid #DCDCDC",
                                    borderRadius: 5,
                                    boxSizing: "content-box",
                                    background: "none",
                                    height: "1.5em",
                                    margin: 0,

                                    display: "block",
                                    minWidth: 0,
                                    // width: "80%",

                                    padding: "16.5px 14px",

                                    padding: "0.75rem",
                                    backgroundColor: "transparent",
                                    // style={{ width: "420px" }}
                                  }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  Industrial Type
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={values.industrialType}
                                  // style={{ width: "420px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  Currency
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={values.currency}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  E-mail
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={values.email}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  Supplier Name
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={values.vendorName}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  Contact Person
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={values.contactPerson}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  Contact No
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={
                                    values.contactDetails
                                      ? `${values.contactDetails.countryCode}-${values.contactDetails.contactNo}`
                                      : ""
                                  }
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <MDTypography
                          mt={5}
                          variant="h5"
                          fontWeight="medium"
                          color="inherit"
                        >
                          Address
                        </MDTypography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2} alignItems="center">
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  Building No/Name
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={
                                    values.address &&
                                    values.address.buildingNoName !== undefined
                                      ? values.address.buildingNoName
                                      : ""
                                  }
                                  // style={{ width: "310px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  Floor
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={
                                    values.address &&
                                    values.address.floor !== undefined
                                      ? values.address.floor
                                      : ""
                                  }
                                  // style={{ width: "310px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  Street
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={
                                    values.address ? values.address.street : ""
                                  }
                                  // style={{ width: "310px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  Country
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={
                                    values.address ? values.address.country : ""
                                  }
                                  // style={{ width: "310px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  State
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={
                                    values.address ? values.address.state : ""
                                  }
                                  // style={{ width: "310px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  City
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={
                                    values.address ? values.address.city : ""
                                  }
                                  // style={{ width: "310px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  Pincode
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={
                                    values.address ? values.address.pinCode : ""
                                  }
                                  // style={{ width: "310px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <MDTypography
                          variant="h5"
                          fontWeight="medium"
                          mt={5}
                          color="inherit"
                        >
                          Statutory Information
                        </MDTypography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2} alignItems="center">
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  PAN
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={values.pan}
                                  // style={{ width: "310px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  GST No
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={values.gstNo}
                                  // style={{ width: "310px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  Whether SEZ/Non-SEZ
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={values.sezNonsez}
                                  // style={{ width: "310px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  RCM Applicable
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={values.rcmApplicable}
                                  // style={{ width: "310px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>

                          {values.lutNo && (
                            <>
                              <Grid item size="auto">
                                <MDBox component="form" role="form">
                                  <MDBox>
                                    <MDTypography
                                      variant="h6"
                                      color="inherit"
                                      // style={{ color: "grey", textAlign: "left" }}
                                    >
                                      LUT No
                                    </MDTypography>
                                    <MDInput
                                      fullWidth
                                      name="name"
                                      value={values.lutNo}
                                      // style={{ width: "310px" }}
                                    />
                                  </MDBox>
                                </MDBox>
                              </Grid>
                            </>
                          )}
                          {values.lutDate && (
                            <>
                              <Grid item size="auto">
                                <MDBox component="form" role="form">
                                  <MDBox>
                                    <MDTypography
                                      variant="h6"
                                      color="inherit"
                                      // style={{ color: "grey", textAlign: "left" }}
                                    >
                                      LUT Date
                                    </MDTypography>
                                    <MDInput
                                      fullWidth
                                      name="name"
                                      value={values.lutDate}
                                      // style={{ width: "310px" }}
                                    />
                                  </MDBox>
                                </MDBox>
                              </Grid>
                            </>
                          )}
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  Payment Terms
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={values.paymentTerms}
                                  // style={{ width: "310px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  CIN Number
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={values.cinNumber}
                                  // style={{ width: "310px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  Registered under MSMED Act?
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={values.msmedAct}
                                  // style={{ width: "310px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  Have TDS lower deduction certificate?
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={values.tdsLowerDeduction}
                                  // style={{ width: "310px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item size="auto">
                            <MDBox component="form" role="form">
                              <MDBox>
                                <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  Category Of Supply
                                </MDTypography>
                                <MDInput
                                  fullWidth
                                  name="name"
                                  value={values.categoryOfSupply}
                                  // style={{ width: "310px" }}
                                />
                              </MDBox>
                            </MDBox>
                          </Grid>

                          {values.pfAccountNumber && (
                            <>
                              <Grid item size="auto">
                                <MDBox component="form" role="form">
                                  <MDBox>
                                    <MDTypography
                                      variant="h6"
                                      color="inherit"
                                      // style={{ color: "grey", textAlign: "left" }}
                                    >
                                      PF Account Number
                                    </MDTypography>
                                    <MDInput
                                      fullWidth
                                      name="name"
                                      value={values.pfAccountNumber}
                                      // style={{ width: "310px" }}
                                    />
                                  </MDBox>
                                </MDBox>
                              </Grid>
                              {values.esiAccountNumber && (
                                <>
                                  <Grid item size="auto">
                                    <MDBox component="form" role="form">
                                      <MDBox>
                                        <MDTypography
                                          variant="h6"
                                          color="inherit"
                                          // style={{
                                          //   color: "grey",
                                          //   textAlign: "left",
                                          // }}
                                        >
                                          ESI Account Number
                                        </MDTypography>
                                        <MDInput
                                          fullWidth
                                          name="name"
                                          value={values.esiAccountNumber}
                                          // style={{ width: "310px" }}
                                        />
                                      </MDBox>
                                    </MDBox>
                                  </Grid>
                                </>
                              )}
                            </>
                          )}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <MDTypography
                          variant="h5"
                          fontWeight="medium"
                          mt={5}
                          color="inherit"
                        >
                          Bank Details
                        </MDTypography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2} alignItems="center">
                          {values?.bankDetails?.beneficiaryBank && (
                            <Grid item size="auto">
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    Beneficiary Bank
                                  </MDTypography>
                                  <MDInput
                                    fullWidth
                                    name="name"
                                    value={
                                      values.bankDetails
                                        ? values.bankDetails.beneficiaryBank
                                        : ""
                                    }
                                    // style={{ width: "310px" }}
                                  />
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values?.bankDetails?.bankAddress && (
                            <Grid item size="auto">
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    Beneficiary Address
                                  </MDTypography>
                                  <MDInput
                                    fullWidth
                                    name="name"
                                    value={
                                      values.bankDetails
                                        ? values.bankDetails.bankAddress
                                        : ""
                                    }
                                    // style={{ width: "310px" }}
                                  />
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values?.bankDetails?.accountNumber && (
                            <Grid item size="auto">
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    Account Number
                                  </MDTypography>
                                  <MDInput
                                    fullWidth
                                    name="name"
                                    value={
                                      values.bankDetails
                                        ? values.bankDetails.accountNumber
                                        : ""
                                    }
                                    // style={{ width: "310px" }}
                                  />
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values?.bankDetails?.accountType && (
                            <Grid item size="auto">
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    Account Type
                                  </MDTypography>
                                  <MDInput
                                    fullWidth
                                    name="name"
                                    value={
                                      values.bankDetails
                                        ? values.bankDetails.accountType
                                        : ""
                                    }
                                    // style={{ width: "310px" }}
                                  />
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values?.bankDetails?.accountName && (
                            <Grid item size="auto">
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    Account Name
                                  </MDTypography>
                                  <MDInput
                                    fullWidth
                                    name="name"
                                    value={
                                      values.bankDetails
                                        ? values.bankDetails.accountName
                                        : ""
                                    }
                                    // style={{ width: "310px" }}
                                  />
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values?.bankDetails?.ifscCode && (
                            <Grid item size="auto">
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    IFSC Code
                                  </MDTypography>
                                  <MDInput
                                    fullWidth
                                    name="name"
                                    value={
                                      values.bankDetails
                                        ? values.bankDetails.ifscCode
                                        : ""
                                    }
                                    // style={{ width: "310px" }}
                                  />
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values?.bankDetails?.swiftCodeIban && (
                            <Grid item size="auto">
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    Swift Code/IBAN
                                  </MDTypography>
                                  <MDInput
                                    fullWidth
                                    name="name"
                                    value={
                                      values.bankDetails
                                        ? values.bankDetails.swiftCodeIban
                                        : ""
                                    }
                                    // style={{ width: "310px" }}
                                  />
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values?.bankDetails?.intermediaryRoutingBank && (
                            <Grid item size="auto">
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    Intermediary/Routing Bank
                                  </MDTypography>
                                  <MDInput
                                    fullWidth
                                    name="name"
                                    // value={values.contactDetails.contactNo}
                                    value={
                                      values.bankDetails
                                        ? values.bankDetails
                                            .intermediaryRoutingBank
                                        : ""
                                    }
                                    // style={{ width: "310px" }}
                                  />
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values?.bankDetails
                            ?.swiftCodeOfIntermediaryRoutingBank && (
                            <Grid item size="auto">
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    Swift Code Of Intermediary/RoutingBank
                                  </MDTypography>
                                  <MDInput
                                    fullWidth
                                    name="name"
                                    // value={values.contactDetails.contactNo}
                                    value={
                                      values.bankDetails
                                        ? values.bankDetails
                                            .swiftCodeOfIntermediaryRoutingBank
                                        : ""
                                    }
                                    // style={{ width: "310px" }}
                                  />
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <MDTypography
                          variant="h5"
                          fontWeight="medium"
                          mt={5}
                          color="inherit"
                        >
                          Documents
                        </MDTypography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container alignItems="center" spacing={2}>
                          {values?.attachments?.incorporationCertificate && (
                            <Grid item lg={3}>
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    {" "}
                                    Incorporation Certificate{" "}
                                  </MDTypography>
                                  <MDButton
                                    // style={{ color: "white" }}
                                    color="primary"
                                    variant="contained"
                                    size="small"
                                    style={{
                                      color: "white",
                                      width: "10px",
                                      height: "10px",
                                    }}
                                  >
                                    {" "}
                                    {getDocument(
                                      values.attachments
                                        ? values.attachments
                                            .incorporationCertificate
                                        : "",
                                    )}{" "}
                                  </MDButton>
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values?.attachments?.panCard && (
                            <Grid item lg={3}>
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    {" "}
                                    Pan Card
                                  </MDTypography>
                                  <MDButton
                                    color="primary"
                                    variant="contained"
                                    size="small"
                                    style={{ width: "10px", height: "10px" }}
                                  >
                                    {getDocument(
                                      values.attachments
                                        ? values.attachments.panCard
                                        : "",
                                    )}
                                  </MDButton>
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values?.attachments?.cancelledCheque && (
                            <Grid lg={3} item>
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    color="inherit"
                                    variant="h6"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    {" "}
                                    Cancelled Cheque
                                  </MDTypography>
                                  <MDButton
                                    color="primary"
                                    variant="contained"
                                    size="small"
                                    style={{ width: "10px", height: "10px" }}
                                  >
                                    {getDocument(
                                      values.attachments
                                        ? values.attachments.cancelledCheque
                                        : "",
                                    )}
                                  </MDButton>
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values?.attachments?.validLut && (
                            <Grid lg={3} item>
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    {" "}
                                    Valid LUT
                                  </MDTypography>
                                  <MDButton
                                    color="primary"
                                    variant="contained"
                                    size="small"
                                    style={{ width: "10px", height: "10px" }}
                                  >
                                    {getDocument(
                                      values.attachments
                                        ? values?.attachments?.validLut
                                        : "",
                                    )}
                                  </MDButton>
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values?.attachments?.gstRegistrationCertificate && (
                            <Grid item lg={3}>
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    mt={0}
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    {" "}
                                    GST Registration Certificate
                                  </MDTypography>
                                  <MDButton
                                    color="primary"
                                    variant="contained"
                                    size="small"
                                    style={{ width: "10px", height: "10px" }}
                                  >
                                    {getDocument(
                                      values.attachments
                                        ? values.attachments
                                            .gstRegistrationCertificate
                                        : "",
                                    )}
                                  </MDButton>
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values?.attachments?.contract && (
                            <Grid item lg={3}>
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    mt={0}
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    {" "}
                                    Contract Document
                                  </MDTypography>
                                  <MDButton
                                    color="primary"
                                    variant="contained"
                                    size="small"
                                    style={{ width: "10px", height: "10px" }}
                                  >
                                    {getDocument(
                                      values.attachments
                                        ? values.attachments.contract
                                        : "",
                                    )}
                                  </MDButton>
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values?.attachments?.other && (
                            <Grid item lg={3}>
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    mt={0}
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    {" "}
                                    Other Document
                                  </MDTypography>
                                  <MDButton
                                    color="primary"
                                    variant="contained"
                                    size="small"
                                    style={{ width: "10px", height: "10px" }}
                                  >
                                    {getDocument(
                                      values.attachments
                                        ? values.attachments.other
                                        : "",
                                    )}
                                  </MDButton>
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values.attachments?.sezApproval && (
                            <>
                              <Grid item lg={3}>
                                <MDBox component="form" role="form">
                                  <MDBox>
                                    <MDTypography
                                      variant="h6"
                                      color="inherit"
                                      // style={{ color: "grey", textAlign: "left" }}
                                    >
                                      {" "}
                                      SEZ Approval
                                    </MDTypography>
                                    <MDButton
                                      color="primary"
                                      variant="contained"
                                      size="small"
                                      style={{ width: "10px", height: "10px" }}
                                    >
                                      {getDocument(
                                        values.attachments
                                          ? values.attachments.sezApproval
                                          : "",
                                      )}
                                    </MDButton>
                                  </MDBox>
                                </MDBox>
                              </Grid>
                            </>
                          )}
                          {values.attachments?.pfCertificate && (
                            <Grid lg={3} item>
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    {" "}
                                    PF Certificate
                                  </MDTypography>
                                  <MDButton
                                    color="primary"
                                    variant="contained"
                                    size="small"
                                    style={{ width: "10px", height: "10px" }}
                                  >
                                    {getDocument(
                                      values.attachments
                                        ? values.attachments.pfCertificate
                                        : "",
                                    )}
                                  </MDButton>
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values.attachments?.esiCertificate && (
                            <Grid lg={3} item>
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    mt={0}
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    {" "}
                                    ESI Certificate
                                  </MDTypography>
                                  <MDButton
                                    color="primary"
                                    variant="contained"
                                    size="small"
                                    style={{ width: "10px", height: "10px" }}
                                  >
                                    {getDocument(
                                      values.attachments
                                        ? values.attachments.esiCertificate
                                        : "",
                                    )}
                                  </MDButton>
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values.attachments?.tdsLowerDeductionCertificate && (
                            <Grid lg={3} item>
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    {" "}
                                    TDS Lower Deduction Certificate
                                  </MDTypography>
                                  <MDButton
                                    color="primary"
                                    variant="contained"
                                    size="small"
                                    style={{ width: "10px", height: "10px" }}
                                  >
                                    {getDocument(
                                      values.attachments
                                        ? values.attachments
                                            .tdsLowerDeductionCertificate
                                        : "",
                                    )}
                                  </MDButton>
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                          {values.attachments?.msmeCertificate && (
                            <Grid lg={3} item>
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography variant="h6" color="inherit">
                                    {" "}
                                    MSME Certificate
                                  </MDTypography>
                                  <MDButton
                                    color="primary"
                                    variant="contained"
                                    size="small"
                                    style={{ width: "10px", height: "10px" }}
                                  >
                                    {getDocument(
                                      values.attachments
                                        ? values.attachments.msmeCertificate
                                        : "",
                                    )}
                                  </MDButton>
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                    {location.pathname === `/status/${vendorUserId}` && (
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <MDTypography variant="h5" mt={5} color="inherit">
                            GST Validation Summary
                          </MDTypography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="gridbox">
                            <Grid container spacing={2} display="flex" mb={4}>
                              <Grid item xs={3} display="flex">
                                <MDTypography variant="h6" color="inherit">
                                  Status:
                                </MDTypography>

                                <MDInput
                                  // value={`Status: OK`}

                                  value={values?.sts}
                                  style={{
                                    marginTop: "-10px",
                                    marginLeft: "5px",
                                  }}
                                />
                              </Grid>
                              <Grid item xs={3} display="flex">
                                <MDTypography variant="h6" color="inherit">
                                  E-Invoice Status:
                                </MDTypography>
                                <MDInput
                                  // value={`Status: OK`}

                                  value={values?.einvoiceStatus}
                                  style={{
                                    marginTop: "-10px",
                                    marginLeft: "5px",
                                  }}
                                />
                              </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  border: "1px solid lightgrey",
                                  marginLeft: "10px",
                                  borderRadius: "10px",
                                }}
                              >
                                <MDTypography variant="h5" ml={3.5}>
                                  Filled
                                </MDTypography>
                                <Grid item size="auto">
                                  <MDBox component="form" role="form">
                                    <MDBox display="flex">
                                      <MDTypography
                                        variant="h6"
                                        color="inherit"
                                        // style={{ color: "grey", textAlign: "left" }}
                                      >
                                        GST Validation in GSTIN :
                                      </MDTypography>
                                      <MDInput
                                        name="gstValidationInErp"
                                        value={values?.gstNo}
                                        style={{
                                          marginTop: "-10px",
                                          marginLeft: "5px",
                                        }}
                                        width="fit-content"
                                      />

                                      <IconButton>
                                        <CheckCircleIcon
                                          style={{
                                            color: "green",
                                            marginLeft: "5px",
                                            marginTop: "-10px",
                                          }}
                                        />
                                      </IconButton>
                                    </MDBox>
                                  </MDBox>
                                </Grid>

                                <Grid item size="auto">
                                  <MDBox component="form" role="form">
                                    <MDBox display="flex">
                                      <MDTypography
                                        variant="h6"
                                        color="inherit"
                                        // style={{ color: "grey", textAlign: "left" }}
                                      >
                                        Supplier Name Validation in GSTIN :
                                      </MDTypography>

                                      {validSupplierName ? (
                                        <>
                                          <MDInput
                                            name="gstValidationInErp"
                                            value={values?.supplierName}
                                            style={{
                                              marginTop: "-10px",
                                              marginLeft: "5px",
                                              width: "400px",
                                            }}
                                            width="fit-content"
                                          />
                                          <IconButton>
                                            <CheckCircleIcon
                                              style={{
                                                color: "green",
                                                marginLeft: "5px",
                                                marginTop: "-10px",
                                              }}
                                            />
                                          </IconButton>
                                        </>
                                      ) : (
                                        <>
                                          <MDInput
                                            name="gstValidationInErp"
                                            value={values?.supplierName}
                                            // style={{ width: "310px" }}
                                            width="fit-content"
                                          />
                                          <IconButton>
                                            <CloseIcon
                                              style={{
                                                color: "red",
                                                marginLeft: "5px",
                                                marginTop: "-10px",
                                              }}
                                            />
                                          </IconButton>
                                        </>
                                      )}
                                    </MDBox>
                                  </MDBox>
                                </Grid>
                                <Grid item size="auto">
                                  <MDBox component="form" role="form">
                                    <MDBox display="flex">
                                      <MDTypography
                                        variant="h6"
                                        color="inherit"
                                      >
                                        Pincode Validation in GSTIN :
                                      </MDTypography>
                                      {validPinCode ? (
                                        <>
                                          <MDInput
                                            // value={`Status: OK`}

                                            value={values?.address?.pinCode}
                                            style={{
                                              marginTop: "-10px",
                                              marginLeft: "5px",
                                            }}
                                          />
                                          <IconButton>
                                            <CheckCircleIcon
                                              style={{
                                                color: "green",
                                                marginLeft: "5px",
                                                marginTop: "-10px",
                                              }}
                                            />
                                          </IconButton>
                                        </>
                                      ) : (
                                        <>
                                          <MDInput
                                            // value={`Status: OK`}

                                            value={values?.address?.pinCode}
                                            style={{
                                              marginTop: "-10px",
                                              marginLeft: "5px",
                                            }}
                                          />
                                          <IconButton>
                                            <CloseIcon
                                              style={{
                                                color: "red",
                                                marginLeft: "5px",
                                                marginTop: "-10px",
                                              }}
                                            />
                                          </IconButton>
                                        </>
                                      )}
                                    </MDBox>
                                  </MDBox>
                                </Grid>

                                <Grid item size="auto">
                                  <MDBox component="form" role="form">
                                    <MDBox display="flex">
                                      <MDTypography
                                        variant="h6"
                                        color="inherit"
                                      >
                                        Address Validation in GSTIN :
                                      </MDTypography>
                                      <MDInput
                                        fullWidth
                                        multiline
                                        rows={7}
                                        value={
                                          `Street: ${
                                            values.address?.street || ""
                                          }\n` +
                                          `City: ${
                                            values.address?.city || ""
                                          }\n` +
                                          `State: ${
                                            values.address?.state || ""
                                          }\n`
                                        }
                                        style={{
                                          marginTop: "-10px",
                                          marginLeft: "5px",
                                          whiteSpace: "pre-wrap",
                                          fontSize: "20px",
                                        }}
                                      />
                                      {ValidAddress ? (
                                        <IconButton>
                                          <CheckCircleIcon
                                            style={{
                                              color: "green",
                                              marginLeft: "5px",
                                              marginTop: "-10px",
                                            }}
                                          />
                                        </IconButton>
                                      ) : (
                                        <IconButton>
                                          <CloseIcon
                                            style={{
                                              color: "red",
                                              marginLeft: "5px",
                                              marginTop: "-10px",
                                            }}
                                          />
                                        </IconButton>
                                      )}
                                    </MDBox>
                                  </MDBox>
                                </Grid>
                              </Grid>

                              <Grid
                                item
                                xs={5.5}
                                style={{
                                  border: "1px solid lightgrey",
                                  marginLeft: "20px",
                                  borderRadius: "10px",
                                }}
                              >
                                <MDTypography variant="h5" ml={3.5}>
                                  Expected
                                </MDTypography>
                                <Grid item size="auto">
                                  <MDBox component="form" role="form">
                                    <MDBox display="flex">
                                      <MDTypography
                                        variant="h6"
                                        color="inherit"
                                        // style={{ color: "grey", textAlign: "left" }}
                                      >
                                        GST Validation in GSTIN :
                                      </MDTypography>
                                      <MDInput
                                        name="gstValidationInErp"
                                        value={values?.gstNo}
                                        style={{
                                          marginTop: "-10px",
                                          marginLeft: "5px",
                                        }}
                                      />
                                    </MDBox>
                                  </MDBox>
                                </Grid>

                                <Grid item size="auto">
                                  <MDBox component="form" role="form">
                                    <MDBox display="flex">
                                      <MDTypography
                                        variant="h6"
                                        color="inherit"
                                        // style={{ color: "grey", textAlign: "left" }}
                                      >
                                        Supplier Name Validation in GSTIN :
                                      </MDTypography>

                                      <MDInput
                                        name="gstValidationInErp"
                                        value={values?.gstSupplierName}
                                        style={{
                                          marginTop: "-10px",
                                          marginLeft: "5px",
                                          width: "400px",
                                        }}
                                      />
                                    </MDBox>
                                  </MDBox>
                                </Grid>
                                <Grid item size="auto">
                                  <MDBox component="form" role="form">
                                    <MDBox display="flex">
                                      <MDTypography
                                        variant="h6"
                                        color="inherit"
                                      >
                                        Pincode Validation in GSTIN :
                                      </MDTypography>

                                      <MDInput
                                        // value={`Status: OK`}

                                        value={values?.gstPinCode}
                                        style={{
                                          marginTop: "-10px",
                                          marginLeft: "5px",
                                        }}
                                      />
                                    </MDBox>
                                  </MDBox>
                                </Grid>

                                <Grid item size="auto">
                                  <MDBox component="form" role="form">
                                    <MDBox display="flex">
                                      <MDTypography
                                        variant="h6"
                                        color="inherit"
                                      >
                                        Address Validation in GSTIN :
                                      </MDTypography>
                                      <MDInput
                                        fullWidth
                                        multiline
                                        rows={7}
                                        value={
                                          `Street: ${
                                            values?.addr?.st || ""
                                          }\n` +
                                          `City: ${
                                            values?.addr?.city || ""
                                          }\n` +
                                          `State: ${values?.addr?.stcd || ""}\n`
                                        }
                                        style={{
                                          marginTop: "-10px",
                                          marginLeft: "5px",
                                          whiteSpace: "pre-wrap",
                                          fontSize: "20px",
                                        }}
                                      />
                                    </MDBox>
                                  </MDBox>
                                </Grid>
                              </Grid>
                            </Grid>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    )}

                    {location.pathname === `/status/${vendorUserId}` && (
                      <Accordion expanded={true}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <MDTypography variant="h5" mt={5} color="inherit">
                            Company Additions
                          </MDTypography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container spacing={3}>
                            {/* <Grid item xl={4} lg={4} md={6} xs={12}>
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography variant="h6" color="inherit">
                                    Applicable Company Code
                                  </MDTypography>
                                  <Select
                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        borderRadius: 5,
                                        minHeight: "44px",
                                        height: "auto",
                                      }),
                                    }}
                                    isClearable
                                    className="select-css"
                                    maxMenuHeight={130}
                                    placeholder="Choose one..."
                                    name="companyCode"
                                    value={companyCode}
                                    options={valuesCompanyCode}
                                    onChange={(selectedOption) => {
                                      setCompanyCode(selectedOption);
                                    }}
                                  />
                                </MDBox>
                              </MDBox>
                            </Grid>

                            <Grid item xl={4} lg={4} md={6} xs={12}>
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography variant="h6" color="inherit">
                                    Supplier Group
                                  </MDTypography>
                                  <Select
                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        borderRadius: 5,
                                        minHeight: "44px",
                                        height: "auto",
                                      }),
                                    }}
                                    isClearable
                                    className="select-css"
                                    maxMenuHeight={130}
                                    placeholder="Choose one..."
                                    name="vendorGroup"
                                    value={vendorGroup}
                                    options={valuesVendorGroup}
                                    onChange={(selectedOption) => {
                                      setVendorGroup(selectedOption);
                                    }}
                                  />
                                </MDBox>
                              </MDBox>
                            </Grid> */}

                            <Grid item xs={12} lg={12}>
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography variant="h6" color="inherit">
                                    Remarks
                                  </MDTypography>
                                  <MDInput
                                    fullWidth
                                    multiline
                                    rows={4}
                                    name="remarks"
                                    value={remarks}
                                    autoComplete="off"
                                    onChange={(e) => {
                                      setRemarks(e.target.value);
                                    }}
                                  />
                                </MDBox>
                              </MDBox>
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    )}
                    {location.pathname ===
                      `/registered-suppliers/${vendorUserId}` && (
                      <>
                        <Accordion expanded={true}>
                          <AccordionSummary
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <MDTypography variant="h5" mt={5} color="inherit">
                              Company Additions
                            </MDTypography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Grid container spacing={2} alignItems="center">
                              {/* <Grid item size="auto">
                                <MDBox component="form" role="form">
                                  <MDBox>
                                    <MDTypography variant="h6" color="inherit">
                                      Applicable Company Code
                                    </MDTypography>
                                    <MDInput
                                      fullWidth
                                      value={values.companyCode}
                                    />
                                  </MDBox>
                                </MDBox>
                              </Grid>
                              <Grid item size="auto">
                                <MDBox component="form" role="form">
                                  <MDBox>
                                    <MDTypography variant="h6" color="inherit">
                                      Supplier Group
                                    </MDTypography>
                                    <MDInput
                                      fullWidth
                                      value={values.vendorGroup}
                                    />
                                  </MDBox>
                                </MDBox>
                              </Grid> */}

                              <Grid item xs={12}>
                                <MDBox component="form" role="form">
                                  <MDBox>
                                    <MDTypography variant="h6" color="inherit">
                                      Remarks
                                    </MDTypography>
                                    <MDInput
                                      multiline
                                      rows={4}
                                      fullWidth
                                      value={values.remarks}
                                    />
                                  </MDBox>
                                </MDBox>
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      </>
                    )}
                    {location.pathname ===
                      `/rejected-suppliers/${vendorUserId}` && (
                      <Accordion expanded={true}>
                        <AccordionDetails>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12}>
                              <MDBox component="form" role="form">
                                <MDBox>
                                  <MDTypography
                                    variant="h6"
                                    color="inherit"
                                    // style={{ color: "grey", textAlign: "left" }}
                                  >
                                    Rejection Reason
                                  </MDTypography>
                                  <MDInput
                                    fullWidth
                                    multiline
                                    rows={4}
                                    value={values.rejectReason}
                                    // style={{ width: "310px" }}
                                  />
                                </MDBox>
                              </MDBox>
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    )}
                    <div
                      style={{
                        display: "grid",
                        justifyContent: "center",
                        alignSelf: "center",
                        marginTop: "10px",
                      }}
                    >
                      <pre>
                        {location.pathname === `/status/${vendorUserId}` && (
                          <MDButton
                            type="button"
                            color="secondary"
                            variant="contained"
                            onClick={handleOpenAcceptModal}
                            style={{ backgroundColor: "green" }}
                          >
                            Accept
                          </MDButton>
                        )}
                        <MDButton
                          type="button"
                          color="secondary"
                          variant="contained"
                          onClick={clickHandler}
                          style={{ margin: "5px" }}
                        >
                          Go Back
                        </MDButton>
                        {location.pathname === `/status/${vendorUserId}` && (
                          <MDButton
                            type="button"
                            color="error"
                            variant="contained"
                            onClick={handleOpenRejectModal}
                            style={{ maigin: "5px" }}
                          >
                            Reject
                          </MDButton>
                        )}
                      </pre>
                    </div>
                  </Form>
                )}
              </Formik>

              <Modal
                open={openAcceptModal}
                onClose={handleCloseAcceptModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={acceptStyle}>
                  <MDTypography>
                    Are you sure you want to Accept the Supplier?
                  </MDTypography>
                  <MDBox mt={2} display="flex">
                    <div>
                      <MDButton
                        style={{ width: "100%", marginRight: "1.5rem" }}
                        color="info"
                        variant="outlined"
                        onClick={handleCloseAcceptModal}
                      >
                        Cancel
                      </MDButton>
                    </div>
                    <div style={{ float: "right" }}>
                      <MDButton
                        style={{ width: "100%", marginLeft: "0.5rem" }}
                        color="success"
                        onClick={acceptHandler}
                      >
                        Yes
                      </MDButton>
                    </div>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessAccept}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessAccept(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Supplier accepted successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorAccept}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorAccept(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForAccept}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

              <Modal
                open={openRejectModal}
                onClose={handleCloseRejectModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={acceptStyle}>
                  <MDTypography>
                    Are you sure you want to Reject the Supplier?
                  </MDTypography>
                  <TextField
                    fullWidth
                    label="Comment"
                    variant="outlined"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                  />
                  <MDBox mt={2} display="flex">
                    <div>
                      <MDButton
                        style={{ width: "100%", marginRight: "1.5rem" }}
                        color="info"
                        variant="outlined"
                        onClick={handleCloseRejectModal}
                      >
                        Cancel
                      </MDButton>
                    </div>
                    <div style={{ width: "100%", marginLeft: "0.5rem" }}>
                      <MDButton
                        style={{ width: "12rem" }}
                        color="error"
                        onClick={rejectHandler}
                      >
                        Reject
                      </MDButton>
                    </div>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessReject}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessReject(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Supplier rejected successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorReject}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorReject(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForReject}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </MDBox>
          </MDCard>
        ) : (
          <Backdrop
            sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}

        <Footer />
      </DashboardLayout>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getVendorByVendorIdReducer: state.getVendorByVendorIdReducer,
    getVendorsNotApprovedReducer: state.getVendorsNotApprovedReducer,
    acceptVendorHandlerReducer: state.acceptVendorHandlerReducer,
    rejectVendorHandlerReducer: state.rejectVendorHandlerReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getVendorByVendorId: (vendorUserId, jwtToken) =>
      dispatch(getVendorByVendorId(vendorUserId, jwtToken)),
    getVendorsNotApproved: (jwtToken) =>
      dispatch(getVendorsNotApproved(jwtToken)),
    acceptVendorHandler: (payload, jwtToken) =>
      dispatch(acceptVendorHandler(payload, jwtToken)),
    rejectVendorHandler: (payload, jwtToken) =>
      dispatch(rejectVendorHandler(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(DashboardForm);
